// Copilot: Create TanStack Query hooks for password reset flows. Strong types, no UI here.
import { useMutation } from '@tanstack/react-query'
import type { AxiosError } from 'axios'
import { forgotPassword, passwordReset } from '@/utils/api/user-service'
import type { ApiResponse, SignUpRequest } from '@/utils/api/user-service/models'
import { SignUpRequestApp } from '@/utils/api/user-service/models'

export type ForgotPasswordInput = { email: string }
export type ForgotPasswordError = AxiosError<ApiResponse>

// The generated forgotPassword expects a SignUpRequest-like body. We will only pass email.
export function useRequestPasswordReset() {
  return useMutation<Awaited<ReturnType<typeof forgotPassword>>, ForgotPasswordError, ForgotPasswordInput>({
    mutationKey: ['forgot-password'],
    mutationFn: async (input) => {
      const body: Partial<SignUpRequest> = {
        email: input.email,
        app: SignUpRequestApp.MEMBERSHIP_PORTAL,
      }
      // orval type shows NonReadonly<SignUpRequest>; server accepts email only for request
      return forgotPassword(body as SignUpRequest)
    },
  })
}

export type ResetPasswordInput = { token: string; password: string; email: string }
export type ResetPasswordError = AxiosError<ApiResponse | ApiResponse>

// The generated passwordReset also uses SignUpRequest body; we'll pass token and password
export function useResetPassword() {
  return useMutation<Awaited<ReturnType<typeof passwordReset>>, ResetPasswordError, ResetPasswordInput>({
    mutationKey: ['reset-password'],
    mutationFn: async (input) => {
      const body: Partial<SignUpRequest> = { token: input.token, password: input.password, email: input.email }
      return passwordReset(body as SignUpRequest)
    },
  })
}
